import { PhaseString } from "types/global";



// Tipo esteso di GroupPhase che include le proprietà di CropRecipe
export type ExtendedGroupPhase = {

	/** la PHASE selezionata */
	phase: PhaseString
	/** indica che il gruppo è visualizzato collassato o no */
	collapsed: boolean
	/** i giorni di questa fase */
	days: CombinedDay[]
	/** i giorni selezionati usato in recipe */
	daysSelect?: number[]

	// POLICY RECIPE
	shrink?: Policy
	expand?: Policy

	// CROP
	ratio: number
	shrinkDays: number
	expandDays: number
}

// Tipo esteso per combinare Recipe Day e Crop Day
export type CombinedDay = {
	co2?: number,
	dayPhotoPeriod?: number,
	ec?: number,
	humDay?: number,
	humNight?: number,
	irrigationDuration?: number,
	irrigationPause?: number,
	ledBars?: number,
	nightPhotoPeriod?: number,
	nutrientSolutionId?: number,
	ph?: number,
	phase?: PhaseString,
	position?: number,
	spectrum?: number,
	tempDay?: number,
	tempNight?: number

	tasks?: number[]
}

export type Policy = {
	name: POLICY_NAMES
	dayRef?: number
}

export enum POLICY_NAMES {
	DEFAULT = "default",
	KEEP = "keep_from"
}





export const tooltipsSchrink: {
	[key in POLICY_NAMES]: string
} = {
	[POLICY_NAMES.DEFAULT]: "It shrinks by cutting from the last day",
	[POLICY_NAMES.KEEP]: "First delete in descending order from the left side and if necessary delete in ascending order from the right side of the selected day"
}

export const tooltipsExpand: {
	[key in POLICY_NAMES]: string
} = {
	[POLICY_NAMES.DEFAULT]: "Expands the cycle by copying the last day of the recipe",
	[POLICY_NAMES.KEEP]: "Expands the cycle by copying the selected day of the recipe"
}
